(() => {
  const init = (root = document) => {
    // check if viewport is not mobile to avoid unnecessary listeners
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) return;

    const galleries = root.querySelectorAll('[data-gallery-fade]:not([data-gallery-fade-init])');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      gallery.dataset.galleryFadeInit = '1';

      const layers = Array.from(gallery.querySelectorAll('.card-gallery-fade__layer'));
      if (layers.length < 2) return;

      let timer = null;
      let index = 0;

      const show = (i) => {
        layers.forEach((layer, idx) => {
          layer.classList.toggle('is-active', idx === i);
        });
      };

      const tick = () => {
        index = (index + 1) % layers.length;
        show(index);
      };

      const start = () => {
        stop();
        tick(); // immediate feedback on hover
        timer = window.setInterval(tick, 800);
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
        index = 0;
        show(index);
      };

      // const hoverTarget = gallery.closest('product-card') || gallery;
      const hoverTarget = gallery;
      hoverTarget.addEventListener('mouseover', start);
      hoverTarget.addEventListener('mouseleave', stop);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    init(event.target);
  });

  // Fall back to window load and a delayed re-run in case cards render late
  window.addEventListener('load', () => init());
  setTimeout(() => init(), 400);

  // Observe DOM mutations to catch cards added after initial load (e.g., pagination/hydration)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          init(mutation.target || document);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
